/* global localStorage, location */
import axios from 'axios';
import { isAuthenticated } from './jwt';
import store from '../goodBeefIndex/store';
import { logout as logoutReduxAction } from '../user/actions';
import history from '../goodBeefIndex/gbiHistory';
import { showNotification } from '../notifications/actions';

const getDomain = () => {
  switch (window.location.host) {
    case 'localhost':
      return 'http://localhost:12345';
    case 'localhost:8080':
      return 'http://localhost:12345';
    case 'webserver': // cypress test env
      return 'http://api:12345';
    case 'test.goodbeefindex.org':
      return 'https://staging.api.goodbeefindex.org';
    case 'staging.goodbeefindex.org':
      return 'https://staging.api.goodbeefindex.org';
    case 'alpha.goodbeefindex.org':
      return 'https://alpha.api.goodbeefindex.org';
    case 'beta.goodbeefindex.org':
      return 'https://beta.api.goodbeefindex.org';
    case 'goodbeefindex.org':
      return 'https://api.goodbeefindex.org';
    default:
      return 'https://api.goodbeefindex.org';
  }
};

export const getGraphCMSStage = () => {
  switch (window.location.host) {
    case 'webserver': // cypress test env
      return 'PUBLISHED';
    case 'goodbeefindex.org':
      return 'PUBLISHED';
    default:
      return 'DRAFT';
  }
};

const domain = getDomain();

export const getStandardAxiosConfig = () => {
  return {
    headers: {
      Authorization: localStorage.getItem('jwt'),
      Accept: 'application/json'
      // 'GoodBeef-Index-Release': 'release_2021-01-01'
    }
  };
};

export const parseApiError = error => {
  let msg = '';
  // if (error.response && error.response.status) {
  //   msg += error.response.status + ' ';
  // }
  if (error.response && error.response.data) {
    msg += error.response.data;
  }
  if (msg) return msg;
  return error.toString();
};

const instance = axios.create({
  baseURL: domain,
  headers: {
    Accept: 'application/json',
    'GoodBeef-Index-Release': 'release_2022-11-23_v02'
  }
});

instance.interceptors.response.use(response => {
  if (response.headers['goodbeef-index-update-required']) {
    const now = new Date().valueOf();
    const reloaded = localStorage.getItem('goodbeef-index-reload');
    if (!reloaded || (now - reloaded) > (20 * 1000)) {
      localStorage.setItem('goodbeef-index-reload', now);
      location.reload();
    }
  }
  return response;
}, error => {
  try {
    if (error.response.status === 401) {
      if (isAuthenticated() === false) {
        store.dispatch(logoutReduxAction());
        history.push('/login');
        store.dispatch(showNotification(
          'Login Expired', 'please log in again', 'error', 10
        ));
        throw new Error('Login Expired');
      }
    }
  } catch (error) { /**/ }
  throw error;
});

export default instance;
